import { type RequestStatus } from 'core/domain/Request'

import { AlreadyScheduled } from './AlreadyScheduled'
import { CreateOpenDockAccount } from './CreateOpenDockAccount'
import { Schedule } from './Schedule'
import { ScheduleDateAndTime } from './ScheduleDateAndTime'
import { SendInfo } from './SendInfo'
import { STEPS, type Step } from './steps'
import { WarehouseInstructions } from './WarehouseInstructions'

export function DrawerStep({
  step,
  carrierStatus,
  onCarrierCreated,
}: {
  step: Step
  carrierStatus: RequestStatus
  onCarrierCreated: (carrierId: string) => void
}) {
  switch (step) {
    case STEPS.CREATE_OPENDOCK_ACCOUNT:
      return (
        <CreateOpenDockAccount carrierStatus={carrierStatus} onCarrierCreated={onCarrierCreated} />
      )
    case STEPS.INSTRUCTIONS:
      return <WarehouseInstructions />
    case STEPS.SCHEDULE:
      return <Schedule />
    case STEPS.SCHEDULE_DATE_AND_TIME:
      return <ScheduleDateAndTime />
    case STEPS.SEND_INFO:
      return <SendInfo />
    case STEPS.ALREADY_SCHEDULED:
      return <AlreadyScheduled />
    default:
      return null
  }
}
